<form>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <div class="input-group mb-3">
        <ng-select
          [items]="rfq$ | async"
          bindLabel="internal_sku"
          [addTag]="false"
          [multiple]="false"
          [hideSelected]="true"
          [trackByFn]="trackByFn"
          [loading]="rfqLoading"
          [typeahead]="rfqInput$"
          [(ngModel)]="rfqProduct"
          name="rfqProduct"
          (change)="getPurchaseOrders()"
        >
          <ng-template ng-label-tmp let-item="item">
            [{{ item.internal_sku }}] {{ item.product_name }}
          </ng-template>

          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            [{{ item.internal_sku }}] {{ item.product_name }}
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="form-group purchase-orders">
      <label for="">Select Purchase Order</label>
      <mat-radio-group
        aria-labelledby="po-radio-group-label"
        class="po-radio-group"
        [(ngModel)]="selectedPO"
        name="selectedP0"
      >
        <table class="table table-stripe">
          <thead>
            <tr>
              <th>Received Date</th>
              <th>PO #</th>
              <th>Factory</th>
              <th class="text-right">Received Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rfq of rfqPurchaseOrders">
              <td>
                <mat-radio-button class="example-radio-button" [value]="rfq">
                  <span class="po_date">
                    {{ rfq.receiving_report.received_date | date: 'mediumDate' }}
                  </span>
                </mat-radio-button>
              </td>
              <td>
                <span class="poid">
                  {{ rfq.purchase_order_id | purchaseOrderFormat }}
                </span>
              </td>
              <td>
                <span class="factory">
                  {{
                    rfq.purchase_order_rfq?.purchase_order?.factory.factory_name ||
                      'N/A'
                  }}
                </span>
              </td>
              <td class="text-right">
                {{ rfq.quantity }}
              </td>
            </tr>
            <tr *ngIf="!rfqPurchaseOrders || rfqPurchaseOrders.length == 0">
              <td>
                <input
                  type="date"
                  [(ngModel)]="customPo.received_date"
                  required
                  name="received_date"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  [(ngModel)]="customPo.purchase_order_id"
                  name="purchase_order_id"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="text"
                  [(ngModel)]="customPo.factory_name"
                  name="factory_name"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  [(ngModel)]="customPo.quantity"
                  name="quantity"
                  class="form-control"
                  lumDecimalLimit
                />
              </td>
            </tr>
          </tbody>
        </table>
      </mat-radio-group>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="" class="mr-2">Defective quantity: </label>
          <input
            type="number"
            name="defectiveQty"
            [(ngModel)]="defectiveQty"
            class="form-control"
            lumDecimalLimit
          />
        </div>
      </div>
      <div
        class="col-md-4"
        *ngIf="!rfqPurchaseOrders || rfqPurchaseOrders.length == 0"
      >
        <div class="form-group">
          <label for="" class="mr-2">Unit Price: </label>
          <input
            type="number"
            name="unitPrice"
            [(ngModel)]="customPo.unitPrice"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="" class="mr-2">Unit Of Measure: </label>
          <ng-select
            [items]="unitOfMeasures"
            [(ngModel)]="defective_uom_id"
            bindValue="id"
            bindLabel="name"
            name="defective_uom_id"
            [multiple]="false"
            [clearable]="false"
            class="uom"
          >
          </ng-select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="" class="mr-2">Warehouse: </label>
          <select
            class="form-control"
            name="warehouse_id"
            [(ngModel)]="warehouse_id"
            (ngModelChange)="onWarehouseChange($event)"
          >
            <option *ngFor="let w of warehouses" [value]="w.id">
              {{ w.location_name }}
            </option>
          </select>
        </div>
      </div>
      <ng-container *ngIf="rfqProduct">
        <div class="col-md-4" *ngIf="ftLocationBins">
          <div class="form-group">
            <label for="" class="mr-2">Location: </label>
            <ng-select
              [items]="locations$ | async"
              [(ngModel)]="location_id"
              bindValue="id"
              bindLabel="location_name"
              name="location_id"
              [multiple]="false"
              [clearable]="false"
              [loading]="loadingLocation$ | async"
            >
              <ng-template
                ng-option-tmp
                let-item="item"
                let-index="index"
                let-search="searchTerm"
              >
                <h6>
                  {{ item.location_name }}
                  <i
                    class="fa fa-check-circle is-pick-location"
                    *ngIf="item.is_pick_location"
                  ></i>
                </h6>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </ng-container>
      <div class="col-md-4" *ngIf="enabledBinLocationAndLotTracking">
        <div class="form-group">
          <label for="" class="mr-2">Lot Number: </label>
          <ng-select
            [items]="rfqLots$ | async"
            [(ngModel)]="lot_id"
            bindValue="id"
            bindLabel="lot_number"
            name="lot_id"
            [multiple]="false"
            [clearable]="false"
            [loading]="loadingRfqLot$ | async"
            *ngIf="enabledBinLocationAndLotTracking"
          >
            <ng-template ng-footer-tmp>
              <p class="create-new" (click)="createNewLot()">Create a new Lot</p>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="activeModal.dismiss('')"
      [disabled]="loading"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button (click)="addItems()" type="button" class="btn btn-primary">
      <i class="fas fa-check"></i> Add SKU/Product
    </button>
  </div>
</form>
